@if (fieldTypeId() === FieldTypes.Date) {
    <div [formGroup]="validationForm()">
        <div class="mt-2">
            <label for="minValue">Min Year:</label>
            <input type="number"
                   formControlName="minValue"
                   class="form-control d-inline-block ms-2"
                   data-qa="property-characteristic-date-min-year">
        </div>
        <div class="mt-2">
            <label for="maxValue">Max Year:</label>
            <input type="number"
                   formControlName="maxValue"
                   class="form-control d-inline-block ms-2"
                   data-qa="property-characteristic-date-max-year">
        </div>
    </div>
}

@if (fieldTypeId() === FieldTypes.Number) {
    <div [formGroup]="validationForm()">
        <div class="mt-2">
            <label for="minValue">Min:</label>
            <input type="number"
                   formControlName="minValue"
                   class="form-control d-inline-block ms-2"
                   data-qa="property-characteristic-number-min">
        </div>
        <div class="mt-2">
            <label for="maxValue">Max:</label>
            <input type="number"
                   formControlName="maxValue"
                   class="form-control d-inline-block ms-2"
                   data-qa="property-characteristic-number-max">
        </div>
    </div>
    <div [formGroup]="descriptorForm()">
        <div class="mt-2">
            <label for="format">Format:</label>
            <select formControlName="formatID"
                    class="form-select form-select-sm d-inline-block w-auto ms-2"
                    data-qa="property-characteristic-number-format">
                @for (format of formats; track format) {
                    <option [ngValue]="format.descriptorFormatID">{{ format.format }}</option>
                }
            </select>
        </div>
    </div>
}

@if (fieldTypeId() === FieldTypes.Picklist) {
    <div [formGroup]="validationForm()" class="checkbox">
        <label>
            <input type="checkbox" formControlName="limitToList" data-qa="property-characteristic-picklist-limit-to-list">
            Limit Entries to List
        </label>
    </div>
    @if (picklistLoading) {
        <div>
            <ws-ace-loader [inline]="true"></ws-ace-loader>
        </div>
    }
    <ul class="list-group">
        @for (item of picklist; track item) {
            <li class="list-group-item"
                [ngClass]="{'invisible': picklistSaving}">
                <div class="checkbox m-0 d-inline-block">
                    <label>
                        <input type="checkbox"
                               [(ngModel)]="item.disabled"
                               (change)="savePicklistItem(item)"
                               helpTooltip
                               position="right"
                               tooltipText="Disabled"
                               data-qa="property-characteristic-picklist-item-disabled">
                        <span [ngClass]="{'text-muted': item.disabled}">{{ item.name }}</span>
                    </label>
                </div>
                <button class="ace-btn has-icon btn-primary btn-danger m-0"
                        (click)="deletePicklistItem(item)"
                        data-qa="property-characteristic-picklist-item-delete">
                    <i class="fa fa-trash"></i>
                </button>
            </li>
        }
    </ul>
    @if (addingItem) {
        <div class="d-flex">
            <input type="text"
                   #itemToAdd
                   class="form-control picklist-item-to-add"
                   [(ngModel)]="itemToAddText"
                   data-qa="property-characteristic-picklist-item-to-add">
            <button type="button" class="ace-btn has-icon btn-sm btn-primary" (click)="addPicklistItem()" data-qa="property-characteristic-picklist-add-item">
                <i class="fa fa-save"></i>
            </button>
        </div>
    }
    <button class="ace-btn btn-sm btn-primary float-end"
            (click)="showPicklistItemInput()"
            [hidden]="picklistLoading || picklistSaving || addingItem"
            data-qa="property-characteristic-picklist-show-add-item">Add
    </button>
}

@if (fieldTypeId() === FieldTypes.Text) {
    <div [formGroup]="validationForm()">
        <div class="mt-2">
            <label for="maxChars">Max Characters:</label>
            <input type="text"
                   formControlName="maxLength"
                   class="form-control d-inline-block ms-1"
                   data-qa="property-characteristic-text-max-length">
        </div>
    </div>
}
